import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

/**
 * Floating "back to top", for the pages long enough to strand you.
 *
 * Inventory and Marketplace run to roughly 7,600px on a phone — about twenty screen-heights — and
 * the filters that would let you narrow the list are all at the very top. Scrolling back by hand
 * is the only way home.
 *
 * Hidden until you are two screens down, so it never covers content on a page short enough not to
 * need it. `z-30` keeps it under the menu bar's `z-50`, and it sits above the safe-area inset so
 * it clears the home indicator on a modern iPhone.
 */
export const BackToTop = () => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const threshold = () => window.innerHeight * 2
        const onScroll = () => setVisible(window.scrollY > threshold())
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <button
            type='button'
            aria-label='Back to top'
            title='Back to top'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className={twMerge(
                'fixed right-4 z-30 flex h-11 w-11 items-center justify-center rounded-full',
                'border border-white/25 bg-black/80 backdrop-blur-sm',
                'transition-opacity duration-200 hover:border-white/60 hover:bg-white/10',
                visible ? 'opacity-100' : 'pointer-events-none opacity-0'
            )}
            style={{ bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))' }}
        >
            <FontAwesomeIcon icon={faArrowUp} />
        </button>
    )
}
